/** Slider panel (full-height sidebar), voice variant (floating), close pill, and loading state. */
export const PANEL_CSS = `
    .pw-pnl {
      position: fixed; inset: 0;
      backdrop-filter: blur(5px);
      -webkit-backdrop-filter: blur(5px);
      display: none; align-items: stretch; justify-content: flex-end;
      z-index: 2147483647;
      opacity: 0; transition: opacity 0.3s ease;
      background: rgba(0,0,0,0.4);
      /* Only the open state may steal clicks. During close, inline
         display:flex can linger for the slide-out animation — without this,
         an invisible full-viewport layer blocks the page underneath. */
      pointer-events: none;
      font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    }
    .pw-pnl.open { display: flex; opacity: 1; pointer-events: auto; }
    .pw-pnl.pw-pnl-minimized {
      display: flex;
      opacity: 1;
      background: transparent;
      backdrop-filter: none;
      -webkit-backdrop-filter: none;
      pointer-events: none;
    }

    .pw-pnl-body {
      position: relative;
      width: 90vw; height: 100vh;
      background: #f5f5f5;
      box-shadow: -10px 0 50px rgba(0,0,0,0.5);
      transform: translateX(100%);
      transition: transform 0.4s cubic-bezier(0.22, 0.61, 0.36, 1);
    }
    .pw-pnl.open .pw-pnl-body { transform: translateX(0); }
    .pw-pnl.pw-pnl-minimized .pw-pnl-body {
      visibility: hidden;
      box-shadow: none;
    }

    .pw-pnl-close {
      position: absolute;
      bottom: 25px; right: 100%;
      transform: translateY(-50%);
      width: 32px; height: 36px;
      border-radius: 9999px 0 0 9999px;
      border: 1.2px solid transparent;
      background:
        var(--pw-fill-button) padding-box,
        linear-gradient(transparent, transparent) padding-box,
        var(--pw-border-gradient) border-box;
      box-shadow: -2px 0 12px rgba(0, 0, 0, 0.16);
      cursor: pointer; outline: none;
      display: flex; align-items: center; justify-content: center;
      padding: 0;
      z-index: 10;
      color: var(--pw-text);
    }
    .pw-pnl-close:hover {
      background:
        var(--pw-fill-button) padding-box,
        var(--pw-gradient-overlay) padding-box,
        var(--pw-border-gradient) border-box;
    }
    .pw-pnl-close svg { width: 16px; height: 16px; display: block; }

    .pw-pnl-resume {
      position: fixed;
      right: 0;
      top: 50%;
      min-width: 126px;
      height: 40px;
      transform: translate(100%, -50%);
      border-radius: 9999px 0 0 9999px;
      border: 1.2px solid transparent;
      background:
        var(--pw-fill-button) padding-box,
        linear-gradient(transparent, transparent) padding-box,
        var(--pw-border-gradient) border-box;
      box-shadow: -2px 0 12px rgba(0, 0, 0, 0.16);
      color: var(--pw-text);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 6px;
      opacity: 0;
      padding: 0 12px 0 8px;
      pointer-events: none;
      transition: transform 0.25s ease, opacity 0.2s ease;
      visibility: hidden;
      z-index: 11;
      font: 600 12px/1 var(--pw-font);
      white-space: nowrap;
    }
    .pw-pnl-resume:hover {
      background:
        var(--pw-fill-button) padding-box,
        var(--pw-gradient-overlay) padding-box,
        var(--pw-border-gradient) border-box;
    }
    .pw-pnl-resume:focus-visible,
    .pw-pnl-close:focus-visible {
      outline: 2px solid #40A9FF;
      outline-offset: 2px;
    }
    .pw-pnl-resume svg { width: 16px; height: 16px; display: block; flex: 0 0 auto; }
    .pw-pnl-resume-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: var(--pw-border-gradient);
      box-shadow: 0 0 0 3px rgba(64, 169, 255, 0.12);
      flex: 0 0 auto;
    }
    .pw-pnl.pw-pnl-minimized .pw-pnl-resume {
      transform: translate(0, -50%);
      opacity: 1;
      pointer-events: auto;
      visibility: visible;
    }

    .pw-pnl iframe {
      width: 100%; height: 100%; border: none;
    }

    .pw-pnl.pw-pnl-voice,
    .pw-pnl.pw-pnl-voice.open {
      align-items: flex-end;
      background: transparent;
      backdrop-filter: none;
      -webkit-backdrop-filter: none;
      pointer-events: none;
    }
    .pw-pnl.pw-pnl-voice .pw-pnl-body {
      width: 400px;
      height: 88px;
      max-height: calc(100vh - 32px);
      margin: 0 16px 16px 0;
      border-radius: 16px;
      pointer-events: auto;
      box-shadow: 0 8px 40px rgba(0,0,0,0.25);
      transition: width 0.25s ease, height 0.25s ease, border-radius 0.25s ease;
    }
    .pw-pnl.pw-pnl-voice iframe {
      border-radius: 16px;
    }

    .pw-pnl-loading {
      position: absolute; inset: 0;
      display: flex; align-items: center; justify-content: center;
      background: #f8fafb; color: #6b7280;
      font: 14px/1 system-ui, sans-serif;
    }
    .pw-pnl-spinner {
      width: 28px; height: 28px; border-radius: 50%;
      border: 3px solid rgba(100,160,180,0.2);
      border-top-color: rgba(85,175,182,0.8);
      animation: pw-spin 0.8s linear infinite;
      margin-right: 10px;
    }
`;
